import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * `theme.css` replaces Tailwind's stock scales with semantic ones. tailwind-merge
 * only knows the stock names, so `rounded-card rounded-pill` — a genuine conflict —
 * would survive as both classes, and whichever came last in the stylesheet would
 * win by accident.
 *
 * Registering our scale values here is what makes "the caller's class wins" true.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'canvas',
        'surface',
        'surface-sunken',
        'surface-selected',
        'surface-media',
        'border',
        'border-strong',
        'hairline',
        'ink',
        'ink-2',
        'muted',
        'faint',
        'accent',
        'accent-hover',
        'accent-ink',
        'accent-soft',
        'accent-soft-ink',
        'success',
        'success-bg',
        'warning',
        'warning-bg',
        'danger',
        'danger-bg',
        'overlay',
      ],
      radius: ['pill', 'card', 'control', 'media'],
      text: ['display', 'section', 'body', 'secondary', 'label'],
      font: ['display', 'sans', 'mono'],
      shadow: ['overlay'],
      ease: ['standard'],
    },
  },
});

/** Merge class lists so a caller's utility always wins over the primitive's own. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
